import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {rewards,reward,rewardSimple,rewardAmounts,rewardAmount,rewardTargets,
    rewardTarget,rewardDetails,rewardDetail,rewardDetailsOwner,rewardRanking,rewardTargetRanking,
    rewardDetailsExp,rewardRecover,rewardDetailsPush} = api

/**
 * 查找
 */
export async function findRewards(params) {
    return request({url: rewards, method: 'get', data: params,})
}
/**
 * 创建
 */
export async function createRewards(params) {
    return request({url: rewards, method: 'post', data: params,})
}
/**
 * 查找详情
 */
export async function findReward(params) {
    return request({url: reward, method: 'get', data: params,})
}

/**
 * 编辑
 */
export async function updateReward(params) {
    return request({url: reward, method: 'put', data: params,})
}
/**
 * 编辑
 */
export async function updateRewardSimple(params) {
    return request({url: rewardSimple, method: 'put', data: params,})
}
/**
 * 恢复
 */
export async function recoverReward(params) {
    return request({url: rewardRecover, method: 'put', data: params,})
}
/**
 * 删除
 */
export async function deleteReward(params) {
    return request({url: reward, method: 'delete', data: params,})
}
/**
 * 查询打赏金额
 */
export async function findreWardAmounts(params) {
    return request({url: rewardAmounts, method: 'get', data: params,})
}/**
 * 新增
 */
export async function createWardAmounts(params) {
    return request({url: rewardAmounts, method: 'post', data: params,})
}

export async function findRewardTargets(params) {
    return request({url: rewardTargets, method: 'get', data: params,})
}
/**
 * 创建打赏对象
 */
export async function createRewardTargets(params) {
    return request({url: rewardTargets, method: 'post', data: params,})
}
/**
 * 创建打赏对象
 */
export async function updateRewardTargets(params) {
    return request({url: rewardTargets, method: 'put', data: params,})
}
/**
 * 删除打赏对象
 */
export async function deleteRewardTarget(params) {
    return request({url: rewardTarget, method: 'delete', data: params,})
}

/**
 * 打赏详情
 */
export async function findRewardDetails(params) {
    return request({url: rewardDetails, method: 'get', data: params,})
}

/**
 * 提交打赏
 */
export async function createRewardDetails(params) {
    return request({url: rewardDetails, method: 'post', data: params,})
}
export async function deleteRewardDetail(params) {
    return request({url: rewardDetail, method: 'delete', data: params,})
}
/**
 * 主办方提交打赏
 */
export async function createRewardDetailsOwner(params) {
    return request({url: rewardDetailsOwner, method: 'post', data: params,})
}
/**
 * 打赏排行榜
 */
export async function findRewardRanking(params) {
    return request({url: rewardRanking, method: 'get', data: params,})
}
/**
 * 嘉宾打赏排行榜
 */
export async function findRewardTargetRanking(params) {
    return request({url: rewardTargetRanking, method: 'get', data: params,})
}
/**
 * 导出
 */
export async function expRewardDetails(params) {
    return request({url: rewardDetailsExp, method: 'get', data: params,})
}
/**
 * 推送
 */
export async function pushRewardDetails(params) {
    return request({url: rewardDetailsPush, method: 'post', data: params,})
}






// WEBPACK FOOTER //
// ./src/services/reward.js